import type { CustomerProfileView } from '@voll-intelligence/domain';

/**
 * Uma linha por programa de milhas, `Cia · código` (a companhia cai para o
 * código IATA quando o nome falta). Regra única para o painel de perfil do
 * cliente e a aba Identidade do card — os dois leem o mesmo `mileagePlans`.
 */
export function mileagePlanLines(profile: Pick<CustomerProfileView, 'mileagePlans'>): string[] {
  return (profile.mileagePlans ?? []).map(
    (plan) => [plan.airCompany || plan.airCode, plan.planCode].filter(Boolean).join(' · ') || '—',
  );
}
